import "sweetalert";
import "../../shared/components/wizard_modal.js";

jQuery(function () {
  var inProgress = false;
  var modal;

  // BEHAVIOUR

  jQuery(document).on("click", '[data-behaviour~="remote-content-modal"]', function (event) {
    event.preventDefault();
    loadRemotePage(this);
  });

  // HELPER FUNCTIONS

  function loadRemotePage(trigger, options) {
    if (inProgress) {
      return;
    }
    loadPage(trigger, jQuery.extend({ remote: true }, options));
  }

  function loadPage(trigger, options) {
    var newActionUrl =
      jQuery(trigger).data("url") || jQuery(trigger).attr("href") || jQuery(trigger).find("[href]").attr("href");

    options = jQuery.extend(
      {
        title: jQuery(trigger).data("title") || "Details",
        completeText: jQuery(trigger).data("complete-text") || "Done",
        target: jQuery(trigger).data("modal-target"),
        class: jQuery(trigger).data("modal-modifier-class"),
      },
      options,
    );

    inProgress = true;

    var pageLoad = jQuery.get(newActionUrl, { layout: false });
    pageLoad.always(function () {
      inProgress = false;
    });
    pageLoad.fail(function (response) {
      swal("Error", response.statusText, "error");
    });
    pageLoad.done(function (response) {
      var html = jQuery(response);
      if (jQuery(trigger).data("filter")) {
        var body = jQuery(html).find(jQuery(trigger).data("filter"));
      } else {
        var body = jQuery(html).html();
      }
      executeScripts(html);
      createModal(body, options);
    });
  }

  // Execute any script tags by momentarily attaching the response to the DOM
  function executeScripts(html) {
    html.appendTo("body").detach();
  }

  function createModal(page, options) {
    modal = new WizardModal({ completeText: options.completeText, class: options.class });
    modal.addPage({ header: options.title, body: page });
    modal.show();
    jQuery(modal.container).on("hide", function () {
      modal.destroy();
    });
  }
});
